import { Color } from '@tiptap/extension-color'
import TextAlign from '@tiptap/extension-text-align'
import { TextStyle } from '@tiptap/extension-text-style'
import { EditorContent, useEditor } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import { useEffect } from 'react'
import HtmlEditorToolbar from './HtmlEditorToolbar'
import {
  EditorContentArea,
  EditorScrollBar,
  EditorWrapper
} from './HtmlEditor.styles'
import { isAllowedLinkHref, normalizeHtml } from './htmlEditorUtils'

type HtmlEditorProps = {
  content: string
  onChange: (html: string) => void
}

const HtmlEditor = ({ content, onChange }: HtmlEditorProps) => {
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        link: {
          openOnClick: false,
          autolink: true,
          validate: (href) => isAllowedLinkHref(href)
        }
      }),
      TextStyle,
      Color,
      TextAlign.configure({
        types: ['heading', 'paragraph']
      })
    ],
    content,
    immediatelyRender: false,
    onUpdate: ({ editor: currentEditor }) => {
      onChange(currentEditor.getHTML())
    }
  })

  useEffect(() => {
    if (!editor) return

    const currentContent = normalizeHtml(editor.getHTML())
    const nextContent = normalizeHtml(content)

    if (currentContent !== nextContent) {
      editor.commands.setContent(content, { emitUpdate: false })
    }
  }, [content, editor])

  if (!editor) return null

  return (
    <EditorWrapper>
      <HtmlEditorToolbar editor={editor} />
      <EditorContentArea>
        <EditorScrollBar scrollMode='vertical' heightClass='extra-small'>
          <EditorContent editor={editor} />
        </EditorScrollBar>
      </EditorContentArea>
    </EditorWrapper>
  )
}

export default HtmlEditor
